import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Footer from "./Footer";
import TopBar from "./Topbar";

const EntrepreneurRequirements = () => {
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(() => {
        const saved = localStorage.getItem("entrepreneur_requirements_ack");
        return saved === "true";
    });

    const handleContinue = () => {
        if(isChecked) {
            navigate("/entrepreneur-terms");
        }
    };

    return (
        <>
            <TopBar />
            <div className="font-poppins">
                <div className="max-w-6xl mx-auto p-6 text-cyan-800 bg-white min-h-screen">
                    <h2 className="text-4xl font-bold text-center text-navy mb-2 font-semibold font-poppins">
                        Entrepreneur Requirements
                    </h2>
                    <p className="text-center text-lg font-semibold font-poppins mb-2 text-navy">
                        <strong>
                            Review the Qualifications Before You Apply
                        </strong>
                    </p>
                    <p className="text-center text-text-base font-medium font-poppins mb-2 text-navy">
                        To ensure your company is eligible to raise funds
                        through our platform, please review the following
                        requirements.
                    </p>
                    <p className="text-center text-text-base font-medium font-poppins mb-2 text-navy">
                        These guidelines help us maintain compliance with SEC
                        regulations and provide a positive experience for all
                        participants.
                    </p>

                    <div className="text-sm space-y-4 ml-24 mt-4">
                        <div>
                            <h3 className="text-lg text-navy font-semibold font-poppins">
                                General Eligibility Requirements
                            </h3>
                            <p className="font-regular font-poppins mb-2 text-navy mt-2">
                                To ensure your company is eligible to raise
                                funds through our platform, please review the
                                following requirements.
                            </p>
                            <p className=" font-regular font-poppins mb-2 text-navy">
                                These guidelines help us maintain compliance
                                with SEC regulations and provide a positive
                                experience for all participants.
                            </p>
                            <h3 className="text-lg text-navy font-semibold font-poppins">
                                To submit an application, your company must:
                            </h3>
                            <ul className="list-disc list-inside mt-2 space-y-1 mt-2 font-regular font-poppins">
                                <li>
                                    Be at least 50% woman-owned and operated
                                </li>
                                <li>
                                    Be a U.S.-based entity (no foreign
                                    companies)
                                </li>
                                <li>Not be an investment company</li>
                                <li>
                                    Not be disqualified under “bad actor” rules
                                </li>
                                <li>
                                    Not have exceeded the $5M Reg CF limit in
                                    the past 12 months
                                </li>
                                <li>
                                    Be looking to raise between $150,000 and $5
                                    million
                                </li>
                                <li>Have a current business plan</li>
                                <li>Have a current pitch deck</li>

                                <li>
                                    Have current financial statements and your
                                    most recent tax return
                                </li>
                            </ul>
                        </div>
                        <div className="h-0.5 w-96 bg-navy mx-auto mt-2 rounded"></div>
                        <div>
                            <h3 className="text-lg text-navy font-semibold font-poppins">
                                Financial Requirements Based on Company Age &
                                Raise Amount
                            </h3>

                            <p className="text-text-base text-navy font-semibold font-poppins mt-2">
                                Companies Less Than 120 Days Old:
                            </p>
                            <ul className="list-disc list-inside ml-4 space-y-1 font-regular font-poppins mt-2">
                                <li className="text-navy">
                                    <span className="text-text-base font-regular font-poppin">
                                        Up to $124,000
                                    </span>
                                    <p className="text-sm pl-5 mt-1">
                                        → Financials and tax returns certified
                                        by the principal executive officer
                                    </p>
                                </li>
                                <li className="text-navy">
                                    <span className="text-text-base font-regular font-poppins">
                                        {" "}
                                        $124,001 to $618,000{" "}
                                    </span>
                                    <p className="text-sm pl-5 mt-1">
                                        → Financial statements must be reviewed
                                        by an independent public accountant
                                    </p>
                                </li>
                                <li className="text-navy">
                                    <span className="text-text-base font-regular font-poppins">
                                        More than $618,000
                                    </span>
                                    <p className="text-sm pl-5 mt-1">
                                        → If it&apos;s your first crowdfunding
                                        raise, reviewed financials are
                                        acceptable
                                    </p>
                                    <p className="text-sm pl-5 mt-1">
                                        → Otherwise, audited financial
                                        statements are required
                                    </p>
                                </li>
                            </ul>
                            <p className="text-text-base text-navy font-semibold font-poppins mt-2">
                                Companies Less Than 120 Days Old:
                            </p>
                            <ul className="list-disc list-inside ml-4 space-y-1 font-regular font-poppins mt-2">
                                <li className="text-navy">
                                    <span className="text-text-base font-regular font-poppins">
                                        Up to $124,000
                                    </span>
                                    <p className="text-sm pl-5 mt-1">
                                        → Financials statements and federal
                                        income tax return info (if filed)
                                    </p>
                                    <p className="text-sm pl-5 mt-1">
                                        → Can be certified by your principal
                                        executive officer
                                    </p>
                                </li>
                                <li className="text-navy">
                                    <span className="text-text-base font-regular font-poppins">
                                        {" "}
                                        $124,001 to $618,000{" "}
                                    </span>
                                    <p className="text-sm pl-5 mt-1">
                                        → Reviewed financial statements by an
                                        independent public accountant are
                                        required
                                    </p>
                                </li>
                                <li className="text-navy">
                                    <span className="text-text-base font-regular font-poppins">
                                        More than $618,000
                                    </span>
                                    <p className="text-sm pl-5 mt-1">
                                        → First-time Reg CF raise: Reviewed
                                        financials are accepted
                                    </p>
                                    <p className="text-sm pl-5 mt-1">
                                        → Subsequent raises: Audited financial
                                        statements required
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className="h-0.5 w-96 bg-navy mx-auto mt-2 rounded"></div>
                        <div className="mt-6 bg-yellow-100 border-l-4 border-yellow-500 p-4 text-text-base font-semibold font-poppins">
                            <p>
                                <strong>⚠️ Please Note:</strong> Meeting these
                                requirements is essential before beginning your
                                application. If you&apos;re unsure where to
                                start, contact our support team or review the
                                official SEC guidelines.
                            </p>
                        </div>

                        <div className="flex items-start mt-6">
                            <input
                                type="checkbox"
                                id="acknowledge"
                                checked={isChecked}
                                onChange={(e) => {
                                    setIsChecked(e.target.checked);
                                    localStorage.setItem(
                                        "entrepreneur_requirements_ack",
                                        e.target.checked,
                                    );
                                }}
                                className="mt-2 mr-4 accent-[#F31B1B] scale-125"
                            />
                            <label
                                htmlFor="acknowledge"
                                className="font-poppins font-light italic text-navy"
                            >
                                I have read and understood the eligibility and
                                financial requirements listed above. I confirm
                                that my <br />
                                company meets these qualifications or will meet
                                them prior to submitting an application. I
                                understand that <br /> submitting false or
                                incomplete information may result in
                                disqualification from the fundraising process.
                            </label>
                        </div>

                        <div className="mt-6 flex justify-center">
                            <button
                                onClick={handleContinue}
                                disabled={!isChecked}
                                className={`py-2 px-8 rounded-xl font-bold text-white ${
                                    isChecked
                                        ? "bg-cyan-800 hover:bg-cyan-900"
                                        : "bg-gray-400 cursor-not-allowed"
                                }`}
                            >
                                CONTINUE TO TERMS AND CONDITIONS
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default EntrepreneurRequirements;
